<template lang="">
  <section class="p-0 mt-5 d-none d-lg-flex">
    <div class="row g-0 w-100">
      <div v-if="imagesSquareFirst" class="col">
        <div class="p-1">
          <base-link
            v-if="imagesSquareFirst"
            :to="imagesSquareFirst.action_url || '#'"
          >
            <img
              v-if="
                imagesSquareFirst &&
                imagesSquareFirst.image &&
                !imageErrors[imagesSquareFirst.id]
              "
              v-lazy="imagesSquareFirst.image"
              width="600"
              height="400"
              :alt="imagesSquareFirst.name"
              class="gallery height-gallery"
              @error="imageErrors[imagesSquareFirst.id] = true"
            />
            <div
              v-if="imagesSquareFirst && imageErrors[imagesSquareFirst.id]"
              class="gallery height-gallery border border-light-subtle d-flex justify-content-center align-items-center"
            >
              <span
                class="text-secondary fw-semibold text-capitalize fs-8 px-2 text-center"
              >
                {{ imagesSquareFirst.name }}
              </span>
            </div>
          </base-link>
          <div
            v-if="!imagesSquareFirst"
            class="gallery height-gallery border border-light-subtle"
          />
        </div>
      </div>
      <div v-if="imagesThinToShow.length > 0" class="col">
        <div class="p-1">
          <div class="row row-gap-2">
            <base-link
              v-for="(image, index) in imagesThinToShow"
              :key="index"
              class="d-flex justify-content-center align-items-center"
              :to="image.action_url || '#'"
            >
              <img
                v-if="image.image && !imageErrors[index]"
                v-lazy="image.image"
                width="600"
                height="400"
                :alt="image.name"
                class="gallery height-gallery-center"
                @error="imageErrors[index] = true"
              />
              <div
                v-if="imageErrors[index]"
                class="gallery height-gallery-center border border-light-subtle d-flex justify-content-center align-items-center"
              >
                <span
                  class="text-secondary fw-semibold text-capitalize fs-8 px-2 text-center"
                >
                  {{ image.name }}
                </span>
              </div>
            </base-link>
          </div>
        </div>
      </div>
      <div v-if="imagesSquareSecond" class="col">
        <div class="p-1">
          <base-link
            v-if="imagesSquareSecond"
            :to="imagesSquareSecond.action_url || '#'"
            class="w-100 h-100"
          >
            <img
              v-if="
                imagesSquareSecond &&
                imagesSquareSecond.image &&
                !imageErrors[imagesSquareSecond.id]
              "
              v-lazy="imagesSquareSecond.image"
              width="450"
              height="250"
              :alt="imagesSquareSecond.name"
              class="gallery height-gallery"
              @error="imageErrors[imagesSquareSecond.id] = true"
            />
            <div
              v-if="imagesSquareSecond && imageErrors[imagesSquareSecond.id]"
              class="gallery height-gallery border border-light-subtle d-flex justify-content-center align-items-center"
            >
              <span
                class="text-secondary fw-semibold text-capitalize fs-8 px-2 text-center"
              >
                {{ imagesSquareSecond.name }}
              </span>
            </div>
          </base-link>
          <div
            v-if="!imagesSquareSecond"
            class="gallery height-gallery border border-light-subtle"
          />
        </div>
      </div>
    </div>
  </section>
  <!-- <section class="row g-0 mt-5 d-none d-lg-flex">
        <div
            v-if="imagesSquareFirst"
            class="col"
        >
            <base-link
                v-if="imagesSquareFirst"
                :to="imagesSquareFirst.action_url || '#'"
            >
                <img 
                    v-if="imagesSquareFirst && imagesSquareFirst.image && !imageErrors[imagesSquareFirst.id]"
                    v-lazy="imagesSquareFirst.image"
                    :alt="imagesSquareFirst.name"
                    class="gallery height-gallery"
                    @error="imageErrors[imagesSquareFirst.id] = true;"
                >
                <div 
                    v-if="imagesSquareFirst && imageErrors[imagesSquareFirst.id]"
                    class="gallery height-gallery border border-light-subtle d-flex justify-content-center align-items-center"
                >
                    <span
                        class="text-secondary fw-semibold text-capitalize fs-8 px-2 text-center"
                    >
                        {{ imagesSquareFirst.name }}
                    </span>
                </div>
            </base-link>
            <div
                v-if="!imagesSquareFirst"
                class="gallery height-gallery border border-light-subtle"
            />
        </div>
        <div 
            v-if="imagesThinToShow.length > 0"
            class="col"
        >
            <div class="row row-gap-2">
                <base-link
                    v-for="(image, index) in imagesThinToShow"
                    :key="index"
                    class="d-flex justify-content-center align-items-center"
                    :to="imagesThinToShow.action_url || '#'"
                >
                    <img 
                        v-if="image.image && !imageErrors[index]"
                        v-lazy="image.image"
                        :alt="image.name"
                        class="gallery height-gallery-center"
                        @error="imageErrors[index] = true;"
                    >
                    <div 
                        v-if="imageErrors[index]"
                        class="gallery height-gallery-center border border-light-subtle d-flex justify-content-center align-items-center"
                    >
                        <span
                            class="text-secondary fw-semibold text-capitalize fs-8 px-2 text-center"
                        >
                            {{ image.name }}
                        </span>
                    </div>
                </base-link>
            </div>
        </div>
        <div 
            v-if="imagesSquareSecond"
            class="col "
        >
            
            <base-link
                v-if="imagesSquareSecond"
                :to="imagesSquareSecond.action_url || '#'"
                class="w-100 h-100"
            >
                <img 
                    v-if="imagesSquareSecond && imagesSquareSecond.image && !imageErrors[imagesSquareSecond.id]"
                    v-lazy="imagesSquareSecond.image"
                    :alt="imagesSquareSecond.name"
                    class="gallery height-gallery"
                    @error="imageErrors[imagesSquareSecond.id] = true;"
                >
                <div 
                    v-if="imagesSquareSecond && imageErrors[imagesSquareSecond.id]"
                    class="gallery height-gallery border border-light-subtle d-flex justify-content-center align-items-center"
                >
                    <span
                        class="text-secondary fw-semibold text-capitalize fs-8 px-2 text-center"
                    >
                        {{ imagesSquareSecond.name }}
                    </span>
                </div>
            </base-link>
            <div
                v-if="!imagesSquareSecond"
                class="gallery height-gallery border border-light-subtle"
            />
        </div>
    </section> -->
</template>
<script lang="ts">
import { HomeService } from "@/services/HomeService";
import BaseLink from "@/components/buttons/BaseLink.vue";
import { getFinalEshopUrl } from "@/utils/general";
import {
  VITE_BANNER_BRAND_THIN,
  VITE_BANNER_BRAND_SQUARE,
} from "@/config/constants.js";

export default {
  components: {
    BaseLink,
  },
  data: function () {
    return {
      imagesThin: [],
      imagesSquare: [],
      imageErrors: [],
    };
  },
  computed: {
    imagesThinToShow() {
      return this.imagesThin.slice(0, 2);
    },
    imagesSquareFirst() {
      return this.imagesSquare.length >= 1 ? this.imagesSquare[0] : null;
    },
    imagesSquareSecond() {
      return this.imagesSquare.length >= 2
        ? this.imagesSquare[1]
        : this.imagesSquareFirst;
    },
  },
  mounted() {
    const homeService = new HomeService();
    homeService.getBanners(VITE_BANNER_BRAND_THIN).then((response) => {
      if (response) {
        this.imagesThin = response;
      }
    });
    homeService.getBanners(VITE_BANNER_BRAND_SQUARE).then((response) => {
      if (response) {
        this.imagesSquare = response;
      }
    });
  },
  methods: {
    getFinalUrl(path: string) {
      return getFinalEshopUrl(path);
    },
  },
};
</script>
<style lang="sass" scoped>
.gallery
    width: 100%
    height: 100%
    object-position: center

.height-gallery
    height: auto
    max-height: 440px
    @media (min-width: 992px)
        min-height: 157px

    @media (min-width: 1200px)
        min-height: 200px

    @media (min-width: 1400px)
        min-height: 240px

    @media (min-width: 1700px)
        min-height: 440px

.height-gallery-center
    height: auto
    max-width: 596px

    @media (min-width: 992px)
        height: 75px

    @media (min-width: 1200px)
        min-height: 97px

    @media (min-width: 1400px)
        min-height: 116px

    @media (min-width: 1700px)
        min-height: 216px
</style>
